import { Tabs } from 'app/components/tabs';
import React from 'react';
import { useTranslation } from 'react-i18next';
import type { PlaceTab, ProfileListingResults } from './shared';
import { PlaceAvailableListings } from './place-available-listings';
import { PlaceRegularListings } from './place-regular-listings';

export function PlaceListings({
  available,
  onTabChange,
  ratings,
  regulars,
  searchQuery,
  setSearchQuery,
  tab,
}: {
  available: ProfileListingResults;
  onTabChange: (tab: PlaceTab) => void;
  ratings: React.ReactElement;
  regulars: ProfileListingResults;
  searchQuery: string;
  setSearchQuery: React.Dispatch<React.SetStateAction<string>>;
  tab: PlaceTab;
}) {
  const { t } = useTranslation();
  let content: React.ReactNode = ratings;
  if (tab === 'available') {
    content = <PlaceAvailableListings results={available} searchQuery={searchQuery} setSearchQuery={setSearchQuery} />;
  } else if (tab === 'regulars') {
    content = <PlaceRegularListings results={regulars} searchQuery={searchQuery} setSearchQuery={setSearchQuery} />;
  }
  return (
    <>
      <Tabs
        value={tab}
        tabs={[
          { value: 'available', label: t('tabs.available', { ns: 'neighbour-profile' }) },
          { value: 'regulars', label: t('tabs.regulars', { ns: 'neighbour-profile' }) },
          { value: 'reviews', label: t('tabs.reviews', { ns: 'neighbour-profile' }) },
        ]}
        onPress={(nextTab) => onTabChange(nextTab as PlaceTab)}
      />
      {content}
    </>
  );
}
